import projImg1 from '../assets/img/projects/1.png';
import projImg2 from '../assets/img/projects/2.png';
import projImg3 from '../assets/img/projects/3.png';
import projImg4 from '../assets/img/projects/4.png';
import projImg5 from '../assets/img/projects/5.png';
import projImg6 from '../assets/img/projects/6.png';
import projImg7 from '../assets/img/projects/7.png';
import projImg8 from '../assets/img/projects/8.png';
import projImg9 from '../assets/img/projects/9.png';
import projImg10 from '../assets/img/projects/10.png';
import navIcon1 from '../assets/img/svg/github.svg';
import look from '../assets/img/svg/search.svg';

export const projects = [
  {
    title: 'Business Startup',
    description: 'Development',
    imgUrl: projImg4,
    gitHubHref: 'https://github.com/IvanTymoshchuk/sport-life',
    gitHub: navIcon1,
    projHubHref: 'https://margomarm.github.io/september-project/',
    proj: look,
  },
  {
    title: 'Business Startup',
    description: 'Development ( Team lead )',
    imgUrl: projImg6,
    gitHubHref: 'https://github.com/IvanTymoshchuk/eskimo',
    gitHub: navIcon1,
    projHubHref: 'https://ivantymoshchuk.github.io/eskimo/',
    proj: look,
  },
  {
    title: 'Business Startup',
    description: 'Development ( Team lead )',
    imgUrl: projImg3,
    gitHubHref: 'https://github.com/IvanTymoshchuk/cinemania',
    gitHub: navIcon1,
    projHubHref: 'https://alexkorpol.github.io/cinemania/',
    proj: look,
  },
  {
    title: 'Business Startup',
    description: 'Design & Development',
    imgUrl: projImg10,
    gitHubHref: 'https://github.com/IvanTymoshchuk/gym',
    gitHub: navIcon1,
    projHubHref: 'https://ivantymoshchuk.github.io/gym/',
    proj: look,
  },
  {
    title: 'Business Startup',
    description: 'Design & Development',
    imgUrl: projImg5,
    gitHubHref: 'https://github.com/IvanTymoshchuk/creative-scroll',
    gitHub: navIcon1,
    projHubHref: 'https://ivantymoshchuk.github.io/creative-scroll/',
    proj: look,
  },
  {
    title: 'Phonebook',
    description: 'Design & Development',
    imgUrl: projImg2,
    gitHubHref: 'https://github.com/IvanTymoshchuk/goit-react-hw-08-phonebook',
    gitHub: navIcon1,
    projHubHref: 'https://ivantymoshchuk.github.io/goit-react-hw-08-phonebook/',
    proj: look,
  },
];

export const projects2 = [
  {
    title: 'Business Startup',
    description: 'Development',
    imgUrl: projImg7,
    gitHubHref: 'https://github.com/IvanTymoshchuk/barbershop',
    gitHub: navIcon1,
    projHubHref: 'https://ivantymoshchuk.github.io/barbershop/',
    proj: look,
  },
  {
    title: 'Business Startup',
    description: 'Development',
    imgUrl: projImg8,
    gitHubHref: 'https://github.com/IvanTymoshchuk/work',
    gitHub: navIcon1,
    projHubHref: ' https://ivantymoshchuk.github.io/work/',
    proj: look,
  },
  {
    title: 'Business Startup',
    description: 'Development',
    imgUrl: projImg9,
    gitHubHref: 'https://github.com/IvanTymoshchuk/Architecture',
    gitHub: navIcon1,
    projHubHref: 'https://ivantymoshchuk.github.io/Architecture/',
    proj: look,
  },
  {
    title: 'Game',
    description: 'Design & Development',
    imgUrl: projImg1,
    gitHubHref: 'https://github.com/IvanTymoshchuk/Guess-the-number',
    gitHub: navIcon1,
    projHubHref: 'https://ivantymoshchuk.github.io/Guess-the-number/',
    proj: look,
  },
];
